// CSS Modules - component class name prefix: ContentOverviewTeaser__

<template>
  <figure :class="$style.container" @click="$emit('clicked')">
    <a :class="$style.mediaLink" v-if="primaryLink" :href="primaryLink">
      <img :src="image" :alt="title" />
    </a>
    <a :class="$style.mediaLink" v-else>
      <img :src="image" :alt="title" />
    </a>
    <figcaption>
      <a v-if="primaryLink" :href="primaryLink">
        <span>{{ title }}</span>
        <div v-if="copy">{{ copy }}</div>
      </a>
      <a v-else>
        <span>{{ title }}</span>
        <div v-if="copy">{{ copy }}</div>
      </a>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: "ContentOverviewTeaser",
  props: {
    image: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    copy: {
      type: String,
      required: false,
      default: ""
    },
    primaryLink: {
      type: String,
      default: ""
    }
  },
};
</script>

<style module lang="scss">
@import "./ContentOverviewTeaser.scss";
</style>
